import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import PropTypes from 'prop-types';
import UpgradeTheme from '@upgrade/themes/themes/upgrade';
import Icon from '../Icon';
import Text from '../Typography/Text';
import { IconTextContainer, StyledText } from './styles';
function IconText({
  alignItems = 'center',
  children,
  color = 'contentWeak',
  gap = 'sm',
  icon,
  iconColor,
  iconSize = '1.5rem',
  justify = 'start',
  textFirst = false,
  textProps,
  ...props // Accept all URC's Margin props, given IconTextContainer is a styled(Margin), and also a div
}) {
  return /*#__PURE__*/React.createElement(IconTextContainer, _extends({
    $alignItems: alignItems,
    $gap: gap,
    $justify: justify
  }, props), /*#__PURE__*/React.createElement(Icon, {
    icon,
    size: iconSize,
    color: iconColor ?? color
  }), /*#__PURE__*/React.createElement(StyledText, _extends({
    color: color
  }, textProps, {
    $textFirst: textFirst
  }), children));
}
IconText.propTypes = {
  alignItems: PropTypes.string,
  children: PropTypes.node.isRequired,
  color: PropTypes.string,
  gap: PropTypes.oneOf(Object.keys(UpgradeTheme.spacing)),
  icon: PropTypes.node.isRequired,
  iconColor: PropTypes.string,
  iconSize: PropTypes.string,
  justify: PropTypes.string,
  textFirst: PropTypes.bool,
  textProps: PropTypes.shape(Text.propTypes)
};
export default IconText;
//# sourceMappingURL=index.js.map